import {delay} from 'redux-saga';
import {all, call, put, takeEvery, select} from 'redux-saga/effects';
import {stopSubmit} from 'redux-form/immutable';
import {notify} from 'common/notify';

import * as action from '../actions';
import * as selector from '../selectors';
import * as dataContext from '../dataProvider/dataContext';

function* loadBookings({date}) {
	const settings = yield select(selector.getSettings);
	yield put(action.calcIntervals({date, settings}));

	try {
		const response = yield call(dataContext.getBookings, date);
		yield put(action.loadBookings.success({date, list: response}));
	} catch (err) {
		yield put(action.loadBookings.failure());
		yield put(notify.error((err.response.data && err.response.data.message) || 'Произошла ошибка при загрузке броней', 'Ошибка'));
	}
}

function* loadMyBookings() {
	const uuid = yield select(selector.getAppUuid);
	try {
		const response = yield call(dataContext.getMyBookings, uuid);
		yield put(action.loadMyBookings.success({list: response}));
	} catch (err) {
		yield put(action.loadMyBookings.failure());
		yield put(notify.error((err.response.data && err.response.data.message) || 'Произошла ошибка при загрузке ваших броней', 'Ошибка'));
	}
}

function* loadTables() {
	try {
		const response = yield call(dataContext.getTables);
		yield put(action.loadTables.success({list: response}));
	} catch (err) {
		yield put(action.loadTables.failure());
		yield put(notify.error((err.response.data && err.response.data.message) || 'Произошла ошибка при загрузке столов', 'Ошибка'));
	}
}

// проверяет, не попадает ли выбранное время на уже занятые места
function* checkIfSelectedIntersect() {
	yield delay(1000); // из-за того, что иногда не успевает сняться выделение после совершения брони
	const {safeTime} = yield select(selector.getSettings);
	const bookings = yield select(selector.getBookings);
	const selectedTableId = yield select(selector.getSelectedTableId);
	const selectedIntervals = yield select(selector.getSelectedIntervals);

	const bookingsList = bookings.get('list').toJS();

	const intersect = selectedIntervals.length && selectedIntervals.some(interval => {
		return bookingsList.some(booking => {
			return booking.table_id === selectedTableId
				&& interval.date.getTime() >= booking.from.getTime() - safeTime*60*1000
				&& interval.date.getTime() < booking.till.getTime() + safeTime*60*1000;
		});
	});
	if (intersect) {
		yield put(action.unselectAll());
		yield put(notify.show({
			message: 'Кто-то только что забронировал выбранное вами время... Пожалуйста, начните выбор заново.',
			position: 'bc',
			autoDismiss: 0,
		}, 'warning'));
	}
}

// проверяет, не выходит ли выбранное время за временные рамки
function* checkIfSelectedInsideIntervals() {
	const selectedIntervals = yield select(selector.getSelectedIntervals);
	if (selectedIntervals.length) {
		const intervals = yield select(selector.getIntervals);
		const insideIntervals = selectedIntervals.every(selectedInterval => {
			return intervals.some(interval => {
				return selectedInterval.date.getTime() === interval.getTime();
			});
		});
		if (!insideIntervals) {
			yield put(action.unselectAll());
			yield put(notify.show({
				message: 'Часть выбранного вами времени более недоступно. Пожалуйста, начните выбор заново.',
				position: 'bc',
				autoDismiss: 0,
			}, 'warning'));
		}
	}
}

function* sendFormSaga({form, resolve, reject}) {
	try {
		const response = yield call(dataContext.sendForm, form);
		yield put(action.book.success({response}));
		yield put(notify.success('Успешно забронировано!'));
		resolve();
	} catch (err) {
		yield put(action.book.failure({errors: err.response.data}));

		if (err.response.data) {
			const errors = err.response.data.reduce((errors, error) => {
				return {...errors, ...{_error: error.message}};
			}, {});
			yield put(stopSubmit('bookForm', errors));
		}
		yield put(notify.error('При бронировании стола произошла ошибка'));
		reject();
	}
}

function* cancelMyBooking({booking_id}) {
	const uuid = yield select(selector.getAppUuid);
	try {
		const response = yield call(dataContext.cancelMyBooking, booking_id, uuid);
		yield put(action.cancelMyBooking.success({response}));
		yield put(notify.success('Ваша бронь отменена'));
	} catch (err) {
		yield put(action.cancelMyBooking.failure());

		yield put(notify.error((err.response.data && err.response.data.message) || 'Произошла ошибка при отмене бронирования', 'Ошибка'));
	}
}

export default function* sagas() {
	return yield all([
		takeEvery(action.uuid, loadMyBookings),
		takeEvery(action.loadBookings.request, loadBookings),
		takeEvery(action.loadBookings.success, checkIfSelectedIntersect),
		takeEvery(action.calcIntervals, checkIfSelectedInsideIntervals),
		takeEvery(action.loadMyBookings.request, loadMyBookings),
		takeEvery(action.cancelMyBooking.request, cancelMyBooking),
		takeEvery(action.cancelMyBooking.success, loadMyBookings),
		takeEvery(action.loadTables.request, loadTables),
		takeEvery(action.book.request, sendFormSaga),
		takeEvery(action.book.success, loadMyBookings),
	]);
}



// WEBPACK FOOTER //
// ./src/sagas/bookSaga.js